import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Amplify } from "aws-amplify";
import awsExports from "./aws-exports";
import FeedbackForm from "./feedbackForm";
import PrivacyPolicy from "./PrivacyPolicy";
import Home from "./Home";
import { Header, Footer } from "./Layout";

Amplify.configure(awsExports);

export default function App() {
  return <BrowserRouter><a className="skip-link" href="#main">Skip to content</a><Header />
    <main id="main"><Routes>
      <Route path="/" element={<Home />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/support" element={<FeedbackForm />} />
      <Route path="*" element={<section className="wrap policy"><h1>Let’s find your way back.</h1><p>This page isn’t here. <a href="/">Visit Focus Cards</a> or <a href="/support">contact support</a>.</p></section>} />
    </Routes></main><Footer /></BrowserRouter>;
}
